import { helpers } from '@vuelidate/validators';

export const phoneNumberValidator = helpers.withMessage(
  'Please enter a valid US phone number"',
  (value: string | null | undefined) => {
    if (!value) {
      return true;
    }

    return /^(\+1)?\d{10}$/.test(value);
  },
);

export const isNotFutureDateValidator = helpers.withMessage(
  'Date cannot be in the future',
  (value: string | undefined) => {
    if (!value) return true;
    return new Date(value) <= new Date();
  },
);

export const isNumberValidator = helpers.withMessage('Only numbers are allowed', (value: string | undefined) => {
  if (!value) return true;
  return /^\d+$/.test(value);
});

export const isAgeBetweenValidator = helpers.withMessage(
  'Age must be between 18 and 125 years',
  (value: string | undefined) => {
    if (!value) return true;

    const today = new Date();
    const inputDate = new Date(value);

    let age = today.getFullYear() - inputDate.getFullYear();
    const monthDiff = today.getMonth() - inputDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < inputDate.getDate())) {
      age--;
    }

    return age >= 18 && age <= 125;
  },
);

export const checkboxCheckedValidator = (message: string) => helpers.withMessage(message, (value: boolean) => value);

export const ssnMatchValidator = helpers.withMessage(
  'SSN numbers must match',
  (value: string, siblings: { nationalId: string }) => value === siblings.nationalId,
);

/**
 * Creates a validator that ensures end date is not before start date
 * @param startDateField - name of the field containing the start date
 * @returns validator function
 */
export const endDateValidator = (startDateField: string) =>
  helpers.withMessage(
    'End date cannot be before start date',
    (value: string | undefined, siblings: Record<string, string>) => {
      const startDate = siblings[startDateField];
      if (!value || !startDate) {
        return true;
      }

      return new Date(startDate) <= new Date(value);
    },
  );
